// extracted by mini-css-extract-plugin
export var cardIcon = "_47-4";
export var checkboxCard = "_47-0";
export var checkboxCardSelected = "_47-1";
export var disabled = "_47-2";
export var outerBorder = "_47-3";
export var spacerMedium = "_47-7";
export var spacerSmall = "_47-6";
export var spacerXsmall = "_47-5";